import { smoothScroll } from '@doltech/utils/lib/smooth-scroll';
import { isNil } from 'lodash';
import * as React from 'react';
import { useIsomorphicLayoutEffect, usePrevious } from 'react-use';

interface UseSavedScrollPositionOptions {
  scrollContainerId: string;
  trackedValue: number;
  deps: any[];
  scrollWhen?: () => boolean;
  updateScrollValueWhen?: () => boolean;
}

export const useSavedScrollPosition = (props: UseSavedScrollPositionOptions) => {
  const {
    scrollContainerId,
    trackedValue,
    deps,
    scrollWhen = () => true,
    updateScrollValueWhen = () => true,
  } = props;
  const prevSectionIndex = usePrevious(trackedValue);
  const [scrollHolder, setScrollHolder] = React.useState<number[]>([]);

  React.useMemo(() => {
    // store scroll position before change
    setScrollHolder((prevScrollHolder) => {
      const scrollContainer = document.getElementById(scrollContainerId);
      if (
        scrollContainer &&
        scrollContainer.className.includes('visible') &&
        updateScrollValueWhen()
      ) {
        prevScrollHolder[prevSectionIndex] = scrollContainer?.scrollTop;
      }
      return prevScrollHolder;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackedValue, ...deps]);

  useIsomorphicLayoutEffect(() => {
    if (scrollWhen()) {
      const scrollContainer = document.getElementById(scrollContainerId);
      let scrollTo = 0;
      if (isNil(scrollHolder[trackedValue]) === false) {
        scrollTo = scrollHolder[trackedValue];
      }
      smoothScroll(300, scrollContainer, scrollTo);
    }
  }, [trackedValue, ...deps]);
  return scrollHolder;
};
